import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText, Check } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { POLICIES } from "../mock";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Policies = () => {
  const { t, lang } = useLanguage();
  const sections = POLICIES[lang] || POLICIES.es;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <Header onBookClick={() => {}} />

      {/* Title band */}
      <section className="relative bg-[#0d3b43] text-white">
        <div className="max-w-4xl mx-auto px-6 py-14">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-white transition-colors mb-5"
          >
            <ArrowLeft className="w-4 h-4" /> {t("backHome")}
          </Link>
          <div className="flex items-start gap-3">
            <span className="w-12 h-12 shrink-0 rounded-xl bg-white/10 flex items-center justify-center text-cyan-300">
              <FileText className="w-6 h-6" />
            </span>
            <div>
              <h1 className="font-display font-extrabold text-3xl sm:text-4xl leading-tight">
                {t("policiesTitle")}
              </h1>
              <p className="text-white/75 mt-2">{t("policiesIntro")}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="max-w-4xl mx-auto px-6 py-14">
        <div className="space-y-10">
          {sections.map((sec, i) => (
            <div key={sec.title}>
              <div className="flex items-center gap-3 mb-5">
                <span className="w-8 h-8 rounded-lg bg-teal-600 text-white font-bold flex items-center justify-center text-sm">
                  {i + 1}
                </span>
                <h2 className="font-display font-bold text-2xl text-[#0d3b43]">
                  {sec.title}
                </h2>
              </div>
              <ul className="space-y-3">
                {sec.items.map((item, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-3 rounded-xl border border-teal-100 bg-teal-50/40 p-4"
                  >
                    <Check className="w-5 h-5 text-teal-600 shrink-0 mt-0.5" />
                    <span className="text-[15px] leading-relaxed text-slate-700">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Policies;
